enum Keys {
    FREQUENCY = 'upd_freq',
    PERIOD = 'upd_pr',
    EMAIL = 'upd_email',
}

export class Cookie {
    static get () {
        const email = Cookie.getSingle(Keys.EMAIL);
        const period = +Cookie.getSingle(Keys.PERIOD);
        const frequency = +Cookie.getSingle(Keys.FREQUENCY);
        return { email, period, frequency };
    }

    private static getSingle (key: string) {
        const match = document.cookie.match(new RegExp(key + '=([^;]+)'));
        return match && match[1] ? decodeURIComponent(match[1]) : null;
    }

    static unset () {
        Cookie.set({ email: '', period: '', frequency: '' }, 0);
    }

    static set ({ email, frequency, period }, expires = 365) {
        const date = new Date();
        date.setTime(date.getTime() + (expires * 24 * 60 * 60 * 1000));
        [
            { key: Keys.EMAIL, value: email },
            { key: Keys.FREQUENCY, value: frequency },
            { key: Keys.PERIOD, value: period }
        ].forEach(prop => {
            document.cookie = [
                prop.key,
                '=',
                encodeURIComponent(prop.value),
                '; expires=' + date.toUTCString(),
                '; path=/'
            ].join('');
        });
    }
}
